import type { Directive, DirectiveBinding } from 'vue';

const CAPTURE_BUTTON_NAME_ATTRIBUTE = 'data-ph-capture-attribute-button-name';

const updateCaptureButtonName = (el: HTMLElement, binding: DirectiveBinding<string | false | null | undefined>) => {
  if (!binding.value) {
    el.removeAttribute(CAPTURE_BUTTON_NAME_ATTRIBUTE);
    return;
  }

  el.setAttribute(CAPTURE_BUTTON_NAME_ATTRIBUTE, binding.value);
};

export const captureButtonNameDirective: Directive<HTMLElement, string | false | null | undefined> = {
  mounted(el, binding) {
    updateCaptureButtonName(el, binding);
  },
  updated(el, binding) {
    updateCaptureButtonName(el, binding);
  },
};
